import { Box, Heading } from '@chakra-ui/react';

import { Layout } from '@r-client/republic-capital/feature/static-layout';
import {
  CompaniesList,
  getAlphaSortedCompanies,
} from '@r-client/republic-capital/feature/static-portfolio';

import { SEOMetaTags } from '../../components/seo-meta-tags/seo-meta-tags';

export function TeamPage() {
  return (
    <Box>
      <SEOMetaTags title="Portfolio Companies" />
      <Layout padTop gutterBottom>
        <Heading variant="page" textAlign={{ base: 'center', sm: 'left' }}>
          Portfolio
        </Heading>
        <Heading
          variant="pageSubHeader"
          textAlign={{ base: 'center', sm: 'left' }}
          color="blackAlpha.500"
          maxW={{ base: '100%', sm: '75%', md: '60%' }}
          mb={6}
        >
          Represents portfolio assets of funds managed by Republic Capital as of
          September 30, 2023
        </Heading>
        <CompaniesList companies={getAlphaSortedCompanies()} />
        <Heading
          variant="pageSubHeader"
          textAlign={{ base: 'center' }}
          color="blackAlpha.500"
          maxW={{ base: '100%' }}
          mb={6}
        >
          Specific investments described herein do not represent all investment
          decisions made by the funds. The reader should not assume that
          investment decisions identified and discussed were or will be
          profitable. Specific investment advice references provided herein are
          for illustrative purposes only and are not necessarily representative
          of investments that will be made in the future.
        </Heading>
      </Layout>
    </Box>
  );
}

export default TeamPage;
